import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ProveedorService {

  private URL:string = `${environment.URL}/proveedor`;

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
  }

  getSuppliersByDraw(): Observable<any>{
    return this.http.get<any>(`${this.URL}/filter?idEmpresa=1&idTipo=1&idEstado=1`);
  }
}

